export const enum PPKontentCollections {
  Qualifying = 'qualifying_portal',
  AIGWOQualifying = 'aigwo_qualifying_portal',
  PlayerPortalTheOpen = 'player_portal___the_open',
  PlayerPortalAIGWO = 'player_portal___aig_women_s_open',
}

export const CURRENT_CHAMPIONSHIP_COLLECTION = 'CURRENT';
